<template>
	<div class="con" v-loading="loading" style="width: 800px!important;">
		<div class="title">
			{{info.title}}
		</div>
		<div class="flexCenter metas">
			<li>{{info.createTime}}</li>
		</div>
		<div class="content">
			<mavonEditor :value="info.content"  style="box-shadow: none;"
			:subfield="false"
			defaultOpen="preview"
			:toolbarsFlag="false"
		  :editable="false"
		  :scrollStyle="true"
			/>
		</div>
		<!--资源下载-->
		<div class="ziyuanxiazai" v-if="info.type==2">
			<div class="ziyuanxiazaititle">附件（点击下载）：</div>
			<div class="wenjian" v-for="(item,i) in info.newsfile" :key="i">
				<a :href="url + item.url" target="_blank" style="margin-bottom: 20px;display: block;">{{i+1}}、{{item.title}}</a>
			</div>
		</div>
		<!--资源下载-->
		<!--活动报名-->
		<div v-if="info.type==3" style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 50px;">
			<el-button :type="info.baoming==1?'success':'primary'" @click="baomingclick">{{info.baoming==1?'已报名，点击查看':'点击报名'}}</el-button>
		</div>
		
		<div v-if="info.type==3" style="width: 100%;height: 1px;background: #ececec;margin-top: 30px;margin-bottom: 30px;"></div>
		
		
		<!--活动需求调查-->
		<diaocha ref="diaochadata" v-if="info.type==3"></diaocha>
		<!--活动需求调查-->
		<baoming ref="baomings" @tijiaosu="news_detail()"></baoming>
		<!--活动报名-->
	</div>
</template>

<script>
	import { news_detail } from "@/api/news"
	import baoming from "./form/baoming.vue"
		import { getToken } from '@/utils/auth'
	import diaocha from "./form/diaocha.vue"
	export default {
		components:{
			baoming,diaocha
		},
		data(){
			return{
				id:'',
				info:{},
				loading:false,
				
				url:this.$url
			}
		},
		mounted(){
			this.id = this.$route.query.id?this.$route.query.id:'';
			this.news_detail();
		},
		methods:{
			baomingclick(){
				//需要先判断是否登录
				if(getToken()){
					this.$router.push({
						path:"/hdbaoming",
						query:{
							newsid:this.info.id,
							title:this.info.title
						}
					})
					//this.$refs.baomings.handlecreate(this.info);
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
				
			},
			news_detail(){
				this.loading = true
				news_detail({id:this.id}).then(res=>{
					this.loading = false
					console.log("详情",res.data);
					this.info = res.data
					if(res.data.type==3){
						this.$refs.diaochadata.show(this.$route.query.id)
					}
				}).catch(()=>{
					this.loading = false
				})
			},
		},
	}
</script>

<style lang="scss">
	.v-show-content{
		background-color: none!important;
	}
	img{
		width: 100%;
	}
	.ziyuanxiazai{
		width: 100%;
		border-top: 1px dashed #999;
		margin-top: 30px;
		margin-bottom: 30px;
		.wenjian{
			font-size: 16px;
			margin-left: 20px;
			cursor: pointer;
		}
		.ziyuanxiazaititle{
			font-size: 18px;
			font-weight: bold;
			padding-top: 20px;
			padding-bottom: 15px;
			color: #333;
		}
	}
	.con{
		.content{
			width: 100%;
			margin-top: 30px;
		}
	
		margin: 0 auto;
		.metas{
			    margin-top: 20px;
			    margin-bottom: 20px;
			    padding-bottom: 20px;
			    border-bottom: 1px solid #dfdfdf;
				color: #666;
				font-size: 14px;
		}
		.flexCenter{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.title{
			width: 80%;
			margin: 0 auto;
			margin-top: 50px;
			font-size: 22px;
			color: #0e0e0e;
			text-align: center;
			font-weight: blod;
			line-height: 35px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/news/detail.vue